/** PDF mínimo (A4) com uma imagem JPEG gerada no navegador — sem dependências. */
export function pdfDeImagemJpeg(jpegBytes, imgW, imgH) {
  const pageW = 595.28, pageH = 841.89, margem = 36;
  const escala = Math.min((pageW - margem * 2) / imgW, (pageH - margem * 2) / imgH);
  const w = imgW * escala, h = imgH * escala, x = margem, y = pageH - margem - h;
  const enc = new TextEncoder();
  const partes = [];
  const offsets = [];
  let tamanho = 0;
  const add = (bytes) => { partes.push(bytes); tamanho += bytes.length; };
  const addStr = (s) => add(enc.encode(s));
  const obj = (n, corpo) => { offsets[n] = tamanho; addStr(`${n} 0 obj\n`); if (typeof corpo === "string") addStr(corpo); else corpo(); addStr("\nendobj\n"); };
  addStr("%PDF-1.4\n%\u00e2\u00e3\u00cf\u00d3\n");
  obj(1, "<< /Type /Catalog /Pages 2 0 R >>");
  obj(2, "<< /Type /Pages /Kids [3 0 R] /Count 1 >>");
  obj(3, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageW} ${pageH}] /Resources << /XObject << /Im1 4 0 R >> >> /Contents 5 0 R >>`);
  obj(4, () => { addStr(`<< /Type /XObject /Subtype /Image /Width ${imgW} /Height ${imgH} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`); add(jpegBytes); addStr("\nendstream"); });
  const conteudo = `q ${w.toFixed(2)} 0 0 ${h.toFixed(2)} ${x.toFixed(2)} ${y.toFixed(2)} cm /Im1 Do Q`;
  obj(5, `<< /Length ${conteudo.length} >>\nstream\n${conteudo}\nendstream`);
  const xref = tamanho;
  addStr(`xref\n0 6\n0000000000 65535 f \n${[1, 2, 3, 4, 5].map((n) => String(offsets[n]).padStart(10, "0") + " 00000 n \n").join("")}trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`);
  return new Blob(partes, { type: "application/pdf" });
}

export async function canvasParaPdf(canvas) {
  const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
  const bin = atob(dataUrl.split(",")[1]);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return pdfDeImagemJpeg(bytes, canvas.width, canvas.height);
}
